<!-- open Messaging section -->
<div class="fid_frth">
  <div class="messaging_section" (click)="toggleMessagingList()">
    <div class="sdrf_section">
      <span class="messag_ing">
        Messages
        <span
          class="dp_dtl"
          *ngIf="notificationMessageCountData?.unread_messages > 0"
        ></span>
      </span>
      <span>
        <mat-icon>{{
          isMessagingListVisible ? "keyboard_arrow_down" : "keyboard_arrow_up"
        }}</mat-icon>
      </span>
    </div>
  </div>
  <div *ngIf="chatThreads.length > 0">
    <div class="message_planel_open" *ngIf="isMessagingListVisible">
      <div
        *ngFor="let thread of chatThreads"
        class="list_yy"
        [ngClass]="{ sdfrtv: isMessagingListVisible }"
        (click)="goToMessages(thread)"
      >
        <div class="bookign_img">
          <img
            [src]="thread.senderInfo.imgThumbUrl"
            onerror="this.src='../../../../assets/images/user-avatar.svg'"
            style="height: 50px; width: 50px; border-radius: 50%"
            alt=""
            *ngIf="thread.isSender == 0"
          />
          <img
            [src]="thread.receiverInfo.imgThumbUrl"
            onerror="this.src='../../../../assets/images/user-avatar.svg'"
            style="height: 50px; width: 50px; border-radius: 50%"
            alt=""
            *ngIf="thread.isSender == 1"
          />
        </div>
        <div class="booking_heading1">
          <div class="hy_headingh">{{ thread.lastMTime }}</div>
          <h3 class="hyh_hdf" *ngIf="thread.isSender == 0">
            {{ thread.senderInfo.name }}
          </h3>
          <h3 class="hyh_hdf" *ngIf="thread.isSender == 1">
            {{ thread.receiverInfo.name }}
          </h3>
          <h5>(with {{ thread.entity_name }})</h5>
          <p>{{ thread.lastMessage }}</p>
          <div class="msg_status" *ngIf="thread.read_status > 0"></div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="chatThreads.length == 0">
    <div class="messaget_section" *ngIf="isMessagingListVisible">
      <div class="messgae_sect">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="512"
          height="512"
          x="0"
          y="0"
          viewBox="0 0 511.999 511.999"
          style="enable-background: new 0 0 512 512"
          xml:space="preserve"
          class=""
        >
          <g>
            <path
              d="M510.156 401.843 480.419 315.3c14.334-29.302 21.909-61.89 21.96-94.679.088-57.013-21.97-110.92-62.112-151.79-40.15-40.878-93.652-63.889-150.652-64.792-59.105-.934-114.661 21.548-156.428 63.314-40.274 40.273-62.612 93.366-63.319 150.102-39.694 29.886-63.123 76.481-63.046 126.25.037 23.29 5.279 46.441 15.212 67.376L1.551 470.689c-3.521 10.247-.949 21.373 6.713 29.035 5.392 5.393 12.501 8.264 19.812 8.264 3.076 0 6.188-.508 9.223-1.551l59.609-20.483c20.935 9.933 44.086 15.175 67.376 15.212h.248c50.51-.002 97.46-24.035 127.237-64.702 30.987-.816 61.646-8.317 89.363-21.876l86.544 29.738a33.696 33.696 0 0 0 10.959 1.843c8.688 0 17.136-3.412 23.545-9.822 9.104-9.105 12.16-22.326 7.976-34.504zM164.53 470.69h-.199c-20.614-.031-41.085-5.113-59.196-14.695a15.244 15.244 0 0 0-12.078-.942l-61.123 21.003 21.003-61.122a15.24 15.24 0 0 0-.942-12.078c-9.582-18.112-14.664-38.582-14.696-59.197-.051-33.159 12.848-64.588 35.405-88.122 7.368 44.916 28.775 86.306 61.957 118.898 32.937 32.351 74.339 52.949 119.011 59.683-23.588 23.249-55.384 36.572-89.142 36.572zm316.098-55.893c-.867.867-1.895 1.103-3.051.705l-92.648-31.836a15.232 15.232 0 0 0-12.077.942c-26.453 13.994-56.345 21.416-86.447 21.462h-.288c-100.863 0-184.176-81.934-185.774-182.773-.805-50.785 18.513-98.514 54.394-134.395 35.881-35.881 83.618-55.192 134.396-54.392 100.936 1.601 182.926 85.068 182.77 186.063-.047 30.102-7.468 59.995-21.461 86.446a15.24 15.24 0 0 0-.942 12.078l31.835 92.648c.397 1.16.159 2.187-.707 3.052z"
              fill="#b0b0b0"
              opacity="1"
              data-original="#000000"
              class=""
            ></path>
            <path
              d="M376.892 139.512h-181.56c-8.416 0-15.238 6.823-15.238 15.238 0 8.416 6.823 15.238 15.238 15.238h181.56c8.416 0 15.238-6.823 15.238-15.238s-6.822-15.238-15.238-15.238zM376.892 202.183h-181.56c-8.416 0-15.238 6.823-15.238 15.238s6.823 15.238 15.238 15.238h181.56c8.416 0 15.238-6.823 15.238-15.238s-6.822-15.238-15.238-15.238zM307.004 264.852H195.331c-8.416 0-15.238 6.823-15.238 15.238 0 8.416 6.823 15.238 15.238 15.238h111.672c8.416 0 15.238-6.823 15.238-15.238s-6.821-15.238-15.237-15.238z"
              fill="#b0b0b0"
              opacity="1"
              data-original="#000000"
              class=""
            ></path>
          </g>
        </svg>
      </div>
      <div class="message_heaionmdg">
        <h3>No message found</h3>
      </div>
    </div>
  </div>
</div>

<!-- open Messaging section end -->
